var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name},[_c('div',{ref:"inner",staticClass:"u-absolute u-pos-tl u-fit u-bg--white",class:_vm.name+'-inner'})])}
var staticRenderFns = []

export { render, staticRenderFns }